import React from "react";
import PricingPage from "@components/Pages/PricingPage/PricingPage";
export default function Software() {
    return <PricingPage />;
}

export async function getStaticProps({ locale }) {
    return {
        props: {
            messages: (await import(`../locales/${locale}.json`)).default,
        },
    };
}
